import React from 'react';
import {
  LayoutChangeEvent,
  ScrollView,
  TouchableOpacity,
  View,
} from 'react-native';
import { Menu } from 'react-native-paper';

import { PopoverProps } from './types';

const DropDown = React.forwardRef<TouchableOpacity, PopoverProps>(
  (props, ref) => {
    const {
      anchor,
      visible,
      onDismiss,
      onShow,
      setValue,
      list,
      theme,
      popoverStyle,
      accessibilityLabel,
    } = props;

    const [inputLayout, setInputLayout] = React.useState({
      height: 0,
      width: 0,
      x: 0,
      y: 0,
    });

    const onLayout = (event: LayoutChangeEvent) => {
      setInputLayout(event.nativeEvent.layout);
    };

    const setActive = React.useCallback(
      (currentValue: any) => {
        setValue(currentValue);
      },
      [setValue]
    );

    return (
      <Menu
        visible={visible}
        onDismiss={onDismiss}
        theme={theme}
        anchor={
          <TouchableOpacity
            activeOpacity={0.8}
            ref={ref}
            onPress={onShow}
            onLayout={onLayout}
            accessibilityLabel={accessibilityLabel}
          >
            <View pointerEvents="none">{anchor}</View>
          </TouchableOpacity>
        }
        style={{
          maxWidth: inputLayout?.width,
          width: inputLayout?.width,
          marginTop: inputLayout?.height,
          ...popoverStyle,
        }}
      >
        <ScrollView bounces={false}>
          {list.map((_item, _index) => (
            <React.Fragment key={_item.value}>
              <TouchableOpacity
                activeOpacity={0.8}
                onPress={() => {
                  setActive(_item.value);
                  if (onDismiss) {
                    onDismiss();
                  }
                }}
              >
                <React.Fragment>
                  <Menu.Item title={_item.custom || _item.label} />
                </React.Fragment>
              </TouchableOpacity>
            </React.Fragment>
          ))}
        </ScrollView>
      </Menu>
    );
  }
);

export type { PopoverProps };
export default DropDown;
